import {CPSConstants} from "commonUtils/enumerations";

export const headerStyle = {
  avatarStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.2rem",
    marginRight: "0.625rem",
  },
  dropIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1rem",
    marginLeft: "0.625rem",
  },
  buttonStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    textTransform: "none",
    color: "#91FA1F",
    border: "none",
    "&:hover": {
      border: "1px solid #91FA1F",
    },
  },
  typeGraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    padding: "0.75rem 0.063rem 0.75rem 0.063rem",
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  typeGraphyUser: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
    display: "flex",
  },
  actingTypigraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    padding: "0.063rem 0.063rem 0.75rem 0.063rem",
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  selectStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "auto",
    fontSize: CPSConstants.FONTREMTEXT,
  },
  logOutSytle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  FrCppStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    ml: "1rem",
  },
  FrStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    mr: "0.5rem",
  },
  menuItem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
  },
  menuItemHide: {
    display: "none",
  },
  mFALink: {
    p: "1rem",
    cursor: "pointer",
  },
  horizontalDivider: {
    m: "10px 0px",
    borderColor: "rgba(0, 0, 0, 0.5)",
  },
  horizontalDividerGreenColor: {
    m: "10px 0px",
    borderColor: "#9dd262",
  },
};
